export const beginnerRigs = [
  {
    id: 1,
    name: "Blues Starter",
    genre: "Blues",
    guitar: "Fender Stratocaster",
    amp: "Fender Blues Junior",
    description: "Perfect for learning blues fundamentals with classic Fender tone",
    priceRange: "$800 - $1,200",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=300&fit=crop",
    features: ["Versatile pickup switching", "Tube amp warmth", "Great for beginners"]
  },
  {
    id: 2,
    name: "Metal Starter",
    genre: "Metal",
    guitar: "Ibanez RG Series",
    amp: "Boss Katana 50W",
    description: "High-gain setup perfect for modern metal and rock",
    priceRange: "$600 - $900",
    image: "https://images.unsplash.com/photo-1564186763535-ebb21ef5277f?w=400&h=300&fit=crop",
    features: ["High-output pickups", "Built-in effects", "Solid-state reliability"]
  },
  {
    id: 3,
    name: "Budget Practice",
    genre: "All-around",
    guitar: "Yamaha Pacifica",
    amp: "Vox Pathfinder 10",
    description: "Affordable setup that doesn't compromise on quality",
    priceRange: "$300 - $500",
    image: "https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400&h=300&fit=crop",
    features: ["Great value", "Compact size", "Perfect for practice"]
  }
];

export const famousRigs = [
  {
    id: 1,
    artist: "Jimi Hendrix",
    guitar: "Fender Stratocaster",
    amp: "Marshall Super Lead",
    effects: ["Fuzz Face", "Uni-Vibe", "Octavia"],
    description: "The legendary psychedelic rock tone that defined an era",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=300&fit=crop",
    songs: ["Purple Haze", "Voodoo Child", "All Along the Watchtower"]
  },
  {
    id: 2,
    artist: "Kurt Cobain",
    guitar: "Fender Jag-Stang",
    amp: "Fender Twin Reverb",
    effects: ["Boss DS-1", "Small Clone Chorus", "EHX Big Muff"],
    description: "Raw grunge power with a unique guitar design",
    image: "https://images.unsplash.com/photo-1564186763535-ebb21ef5277f?w=400&h=300&fit=crop",
    songs: ["Smells Like Teen Spirit", "Come As You Are", "Lithium"]
  },
  {
    id: 3,
    artist: "Slash",
    guitar: "Gibson Les Paul",
    amp: "Marshall JCM800",
    effects: ["Dunlop Crybaby Wah", "MXR Phase 90"],
    description: "Classic rock tone with singing sustain and bite",
    image: "https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400&h=300&fit=crop",
    songs: ["Sweet Child O' Mine", "November Rain", "Welcome to the Jungle"]
  },
  {
    id: 4,
    artist: "David Gilmour",
    guitar: "Fender Stratocaster",
    amp: "Hiwatt DR103",
    effects: ["Big Muff Pi", "Electric Mistress", "Memory Man Delay"],
    description: "Atmospheric and soaring tones with lush effects",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=300&fit=crop",
    songs: ["Comfortably Numb", "Time", "Shine On You Crazy Diamond"]
  },
  {
    id: 5,
    artist: "Eddie Van Halen",
    guitar: "EVH Wolfgang",
    amp: "Marshall Plexi",
    effects: ["MXR Phase 90", "Echoplex Delay"],
    description: "High-energy rock tone with innovative techniques",
    image: "https://images.unsplash.com/photo-1564186763535-ebb21ef5277f?w=400&h=300&fit=crop",
    songs: ["Eruption", "Jump", "Runnin' with the Devil"]
  },
  {
    id: 6,
    artist: "John Mayer",
    guitar: "PRS Silver Sky",
    amp: "Dumble Overdrive Special",
    effects: ["Ibanez Tube Screamer", "Strymon Timeline"],
    description: "Modern blues-rock with pristine clarity and warmth",
    image: "https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400&h=300&fit=crop",
    songs: ["Gravity", "Slow Dancing", "New Light"]
  }
];
